module.exports = __webpack_public_path__ + "static/media/comet-metallic.a52452c4.png";